
import { useState, useEffect, useCallback } from "react";

const CONSENT_KEY = "finbeam_cookie_consent";

type ConsentStatus = "accepted" | "declined" | null;

function loadGTM() {
  if (document.getElementById("gtm-script")) return;
  const script = document.createElement("script");
  script.id = "gtm-script";
  script.async = true;
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-TGJGRP99');`;
  document.head.appendChild(script);
}

function loadGA() {
  if (document.getElementById("ga-script")) return;
  const script = document.createElement("script");
  script.id = "ga-script";
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-9208VHF5CM";
  document.head.appendChild(script);

  const inline = document.createElement("script");
  inline.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','G-9208VHF5CM');`;
  document.head.appendChild(inline);
}

function loadMetaPixel() {
  if (document.getElementById("fb-pixel-script")) return;
  const script = document.createElement("script");
  script.id = "fb-pixel-script";
  script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','1183358907050334');fbq('track','PageView');`;
  document.head.appendChild(script);
}

function loadAllTracking() {
  loadGTM();
  loadGA();
  loadMetaPixel();
}

export function useCookieConsent() {
  const [consent, setConsent] = useState<ConsentStatus>(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY) as ConsentStatus;
    if (stored) {
      setConsent(stored);
      if (stored === "accepted") {
        loadAllTracking();
      }
    } else {
      setShowBanner(true);
    }
  }, []);

  const accept = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setConsent("accepted");
    setShowBanner(false);
    loadAllTracking();
  }, []);

  const decline = useCallback(() => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setConsent("declined");
    setShowBanner(false);
  }, []);

  return { consent, showBanner, accept, decline };
}
